// extracted by mini-css-extract-plugin
export default {"right-panel-element":"style_right-panel-element__iFIXO","rightPanelElement":"style_right-panel-element__iFIXO"};